<template>
    <div class='extension-container'>
        <div class="fee">
            <h2 class="title">Extension Fee</h2>
            <p class="fee-content" v-text="`₹ ${obj.info.extensionFee}`"></p>
            <p class="fee-caption">Please complete the payment within 24 hours</p>
        </div>        
        <div class="extension_detail">
            <ul class="order-info-list">
                <li class="oi-element" >
                    <span class="left">Extension Fee Paid:</span>
                    <span class="right" v-text="`${obj.info.extensionFeePaid}`"></span>
                </li>
                <li class="oi-element">
                    <span class="left">Extension Processing Fee:</span>
                    <span class="right" v-text="`₹ ${obj.info.extensionServiceFee}`"></span>
                </li>

                <li class="oi-element">
                    <span class="left">Extension Processing Fee Rate:</span>
                    <span class="right" v-text="`₹ ${obj.info.extensionRate * 100} %`"></span>
                </li>
                <li class="oi-element">
                    <span class="left">Interest:</span>
                    <span class="right" v-text="`${obj.info.interest}`"></span>
                </li>                
                <li class="oi-element">
                    <span class="left">Extension Application Date:</span>
                    <span class="right" v-text="`₹ ${obj.info.extensionApplyTime}`"></span>
                </li>
                <li class="oi-element">
                    <span class="left">Number of Extension Days:</span>
                    <span class="right" v-text="`₹ ${obj.info.extensionDay}`"></span>
                </li>
                <li class="oi-element">
                    <span class="left">Due Date:</span>
                    <span class="right" v-text="`₹ ${obj.info.extensionTime}`"></span>
                </li>
            </ul>
        </div>        
        <div class="explain">
            <h2 class="explain-title">Extension Explanation</h2>
            <ul class="explain-list">
                <li class="ex-element">1. After a successful extension, the repayment deadline will be extended. The new due date will be 7 days from the date of the extension request.</li>
                <li class="ex-element">2. There is a time limit for paying the extension fee, and failure to pay within the specified time will result in a failed extension.</li>
                <li class="ex-element">3. The extension fee includes the extension service fee, overdue fee, and interest, minus any previously paid extension fee.</li>
                <li class="ex-element">4. Any amount already repaid will be used first as payment towards the extension fee.</li>
            </ul>
        </div>
        <div class="btn-placeholder"></div>        
        <div class="btn-group">
            <div class="btn-cancel" @click="cancelDialog">
                Abandon extension
            </div>
            <div class="btn-submit" @click="confirm">
                Apply and payment
            </div>
        </div>
        <div class="dialog-wrapper" v-show="cancel_dialog">
            <div class="dialog-confirm">
                <div class="dialog-title">Confirm giving up on extension?</div>
                <div class="dialog-content">
                    Abandoning the extension now will result in the extension request being unsuccessful.
                </div>
                <div class="dialog-footer">
                    <a href="javascript:void(0);" class="btn-submit" @click.prevent="closeDialog">Continue Extension</a>
                    <a href="javascript:void(0);" class="btn-cancel" @click.prevent="confirmCancel">Abandon Extension</a>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="less" scoped>
.explain{
            padding:50px 40px;
            background:#fff;
            width:600px;
            margin:150px auto 0 auto;
            border-radius: 20px;
            .explain-title{
                font-size:36px;
                font-weight:700;
                color:#9C73E2;
                margin-bottom: 50px;
            }
            .explain-list{
                .ex-element{
                    color:#9C73E2;
                    font-size: 28px;
                    margin-bottom:30px;
                    line-height:1.5;
                }
            }
        }
.dialog-wrapper{
        position: fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        width: 100%;
        height: 100%;
        background:rgba(0,0,0,0.8);
        .dialog-confirm{           
            width: 640px;
            margin:0 auto;
            background:#fff;
            border-radius: 15px;
            position:absolute;
            left:50%;
            top:50%;
            transform: translate(-50%, -50%);
            padding:40px 40px;
            .dialog-title{
                font-size: 40px;
                text-align:center;
                color:#9C73E2;
                margin-bottom: 50px;
                font-weight: 700;
                word-break: break-all;
            }
            .dialog-content{
                color:#9C73E2;
                font-size: 36px;
                word-break: break-all;
                .important{
                    .little-title{
                        font-size: 32px;
                        color:#000;
                        padding-left: 15px;
                    }
                    .code{
                       width: 485px;
                       height: 106px;
                       line-height: 106px;
                       color:#000;
                       font-weight: 700;
                       padding-left: 15px;
                       background:#F9F9FB;
                       font-weight: 700;
                       margin:30px 0;
                       text-align:center;
                    }
                }
                .element{
                    overflow:hidden;
                    padding-left: 15px;
                    margin-bottom: 30px;
                    .element-l{
                        float:left;
                        width:150px;
                        font-size: 32px;
                        color:#000;
                        margin-right: 15px;
                    }
                    .element-r{
                        float:left;
                        color:#000;
                        font-size: 32px;
                        height:35px;
                        line-height: 35px;
                    }
                }
            }
            .dialog-footer{
                width: 100%;
                margin-top: 80px;
                .btn-submit{
                    display:block;
                    width: 500px;
                    height: 96px;
                    background: #9C73E2;
                    border-radius: 12px;
                    color: #FFFFFF;
                    text-align: center;
                    line-height: 96px;
                    font-size: 32px;
                    margin:0 auto;
                }
                .btn-cancel{
                    display: block;
                    width: 500px;
                    text-align: center;
                    font-size: 30px;
                    color:#9C73E2;
                    padding:30px 0;
                    margin:0 auto;
                }
            }
        }
    }
    .btn-placeholder{
        height: 250px;        
    }
    .btn-group{
        position: fixed;
        width: 100%;
        bottom:0;
        display: flex;
        justify-content: space-around;
        background:#fff;
        padding:50px 0;
        .btn-cancel{
            width: 320px;
            height: 80px;
            line-height: 80px;
            border-radius: 10px;
            border: 1px solid #9C73E2;
            color:#9C73E2;
            text-align: center;
            font-size: 30px;
        }
        .btn-submit{
            width: 320px;
            height: 80px;
            line-height: 80px;
            background: #9C73E2;
            border-radius: 10px;
            text-align: center;
            font-size: 30px;
            color:#fff;
        }
    }
    .extension-container{
        .fee{
            padding:50px 30px;
            background:#9C73E2;
            height:300px;
            .title{
                font-size: 40px;
                color:#fff;
                text-align: center;
                margin-bottom: 30px;
            }
            .fee-content{
                text-align: center;
                font-size: 60px;
                color:#fff;
                margin-bottom: 50px;
            }
            .fee-caption{
                text-align: center;
                font-size: 30px;
                color:#cbc6f7;
            }
        }
    }
    .extension_detail{
        width:600px;
        border-radius: 30px;
        background:#fff;
        margin:-100px auto;
        padding:35px;
        .order-info-list{
            .oi-element{
                display: flex;
                justify-content: space-between;
                margin-bottom: 40px;
                .left{
                    font-size: 26px;
                    text-align: left;
                    float:left;                    
                }
                .right{
                    font-size: 30px;
                    text-align: left;
                    float:left;
                    color:#776aea;
                }
            }
        }
    }
</style>
<script>
import { onMounted, reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useLoading } from 'vue-loading-overlay'
import { tryExtension, giveUpExtension, applyExtension } from '@api/index.js'
export default {
    setup () {
        const cancel_dialog = ref(false)
        const loading = useLoading()
        const obj = reactive({
            "info":{
                "extensionFeePaid":0,
                "extensionServiceFee":0,
                "extensionRate":0,
                "extensionTime":"****/**/**",
                "interest":0,
                "extensionApplyTime":0,
                "extensionDay":0,
                "orderRepayId":null,
                "extensionId":null,
            }
        })
        let order_id = ref(0)
        const route = useRoute()
        const router = useRouter()
        const cancelDialog = () => {
            cancel_dialog.value = true
        }
        const closeDialog = () =>{
            cancel_dialog.value = false
        }        
        const confirmCancel = () => {
            const loader = loading.show({
                container:null
            })
            giveUpExtension({
                "extensionId": obj.info.extensionId,
                "orderId": order_id.value,
                "orderRepayId": obj.info.orderRepayId
            }).then((resp)=>{
                loader.hide()
                if(resp.code == 0) {
                    router.replace({
                        "path":`/order/`
                    })
                }
            })
        }
        const confirm = () => {
            const loader = loading.show({
                    "container":null
                })
            applyExtension({
                "extensionId": obj.info.extensionId,
                "orderId": order_id.value,
                "orderRepayId": obj.info.orderRepayId
            }).then((res)=>{
                loader.hide()
                if(res.code == 0) {
                    window.location.href = res.data.paymentUrl
                }
            })
        }        
        onMounted(async ()=>{
            order_id.value = route.params.id
            tryExtension(order_id.value).then((resp)=>{
                if(resp.code == 0) {
                    obj['info'] = resp.data
                }
            })
        })

        return {
            order_id,
            obj,
            confirmCancel,
            closeDialog,
            confirm,
            cancelDialog,
            cancel_dialog
        }
    }
}
</script>